import { useContext, useMemo } from 'react'
import { OpenIDContext } from '../../api/openid'
import { useWebSocketConnection, WebSocketContext } from '../../api/websocket'

function WebSocketProvider({ children }: DefaultProps) {
	const { authenticated } = useContext(OpenIDContext)
	const { socket, connected } = useWebSocketConnection(Boolean(authenticated))
	const value = useMemo(() => ({ socket, connected }), [socket, connected])

	return (
		<WebSocketContext.Provider value={value}>
			{children}
		</WebSocketContext.Provider>
	)
}

export default WebSocketProvider
